// extracted by mini-css-extract-plugin
module.exports = {"ColormapContainer":"descriptorColormap_ColormapContainer__2Ycbb","ColormapImage":"descriptorColormap_ColormapImage__1IvGW"};